import { Paperclip, Mic, Send } from 'lucide-react';

export const AISearchBar = ({ placeholder = "Which was my top selling product last month?" }) => {
  return (
    <div 
      className="relative w-full max-w-2xl mx-auto"
      data-testid="ai-search-bar"
    >
      <div className="flex items-center bg-white border border-slate-200 rounded-full shadow-sm hover:shadow-md transition-shadow px-4 py-3">
        <button 
          className="p-2 text-slate-400 hover:text-slate-600 transition-colors"
          data-testid="ai-search-attach"
        >
          <Paperclip className="h-5 w-5" />
        </button>
        <input
          type="text"
          placeholder={placeholder}
          className="flex-1 px-3 py-1 text-slate-700 placeholder:text-slate-400 focus:outline-none bg-transparent"
          data-testid="ai-search-input"
        />
        <button 
          className="p-2 text-slate-400 hover:text-slate-600 transition-colors"
          data-testid="ai-search-mic"
        >
          <Mic className="h-5 w-5" />
        </button>
        <button 
          className="p-2 text-purple-500 hover:text-purple-600 transition-colors"
          data-testid="ai-search-submit"
        >
          <Send className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default AISearchBar;
